<template>
    <div class="dashboard-charts">
        <h2 class="heading">
            {{ graphHeading }}
        </h2>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>
        <div v-show="!noRecordFound && !showSpinner" class="chart-container">
            <div :id="id" class="amcharts-div activity-timeline-report"></div>
        </div>
        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
import AmPie from 'amcharts3/amcharts/pie'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        rotateGraph: {
            type: Boolean,
            default: true,
            required: true,
        },
        labelRotation: {
            type: Number,
            default: 0,
        },
        reset: {
            type: Number,
        },
        graphHeading: {
            type: String,
            required: true,
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataProvider: [],
            valueField: null,
            categoryField: null,
            percents: null,
            resourceApi: null,
            noRecordFound: false,
            showSpinner: true,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        created() {
            let self = this

            window.AmCharts.makeChart(self.id, {
                type: 'serial',
                categoryField: this.categoryField,
                // colors: [
                //     '#f4c200',
                //     '#7f1ec5',
                //     '#00a4f2',
                //     '#00c535',
                //     '#eb8300',
                //     '#f4c200',
                //     '#c1c1c1',
                // ],
                rotate: this.rotateGraph,
                startDuration: 1,
                color: '#1B1B1E',
                fontFamily: 'ProximanovaRegular',
                fontSize: 14,
                categoryAxis: {
                    gridPosition: 'start',
                    axisColor: '#1B1B1E',
                    gridAlpha: 1,
                    gridColor: '#F2F2F6',
                    autoWrap: true,
                    labelRotation: this.labelRotation,

                    labelFunction: function (valueText) {
                        if (valueText.length > 15) {
                            return valueText.substring(0, 15) + '...'
                        } else return valueText
                    },
                },
                trendLines: [],
                graphs: [
                    {
                        accessibleLabel: '[[category]]: [[value]]',
                        balloonText: '[[category]]: [[value]]',
                        id: 'AmGraph-1',
                        title: 'graph 1',
                        type: 'column',
                        valueField: this.valueField,
                        lineColorField: 'color',
                        fillColorsField: 'color',
                        fillAlphas: 1,
                    },
                ],
                guides: [],
                valueAxes: [
                    {
                        id: 'ValueAxis-1',
                        axisColor: '#1B1B1E',
                        gridAlpha: 1,
                        gridColor: '#F2F2F6',
                        title: '',
                        titleFontSize: 14,
                        titleRotation: 0,
                    },
                ],
                allLabels: [],
                balloon: {
                    fillAlpha: 1,
                },
                titles: [
                    {
                        bold: false,
                        id: 'Title-1',
                        size: 0,
                        text: '',
                    },
                ],
                dataProvider: this.dataProvider,
            })
        },
        async getStats() {
            try {
                this.dataProvider = []
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')

                let { data } = await this.resourceApi.list(this.query)
                this.showSpinner = false
                if (data && data.data) {
                    if (data.data.length) {
                        this.categoryField = 'group'
                        this.valueField = 'count'
                        this.dataProvider = data.data
                        _.filter(this.dataProvider, function (obj) {
                            obj.color =
                                'rgb(' +
                                Math.floor(Math.random() * 256) +
                                ',' +
                                Math.floor(Math.random() * 256) +
                                ',' +
                                Math.floor(Math.random() * 256) +
                                ')'
                        })
                    } else {
                        this.noRecordFound = true
                    }
                } else {
                    this.noRecordFound = true
                }
                await this.created()
                // False the page loader after the list has been loaded
            } catch (error) {
                this.$store.commit('setError', error)
            }
        },
    }, // End of Component > created
} // End of export default
</script>
